
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetomalshejghatccab() {



    const cardData =
    {
        keyword: 'Pune to Malshej Ghat Cab Services',
        heading: 'S9 Travels: Pune to Malshej Ghat Cab Services',
        headingDescription: 'S9 Travels offers comfortable, reliable, and affordable cab services from Pune to Malshej Ghat. If you are seeking a nature-filled escape amidst the Sahyadri hills, Malshej Ghat is the perfect destination. The route offers scenic views of waterfalls, valleys, and lush greenery, making it a popular getaway spot. Malshej Ghat is located approximately 130 km from Pune, with a journey time of about 3 to 4 hours. Travel with S9 Travels to enjoy a smooth, hassle-free ride with top-notch amenities and a focus on customer satisfaction.',

        top: 'Top Places to Visit in Malshej Ghat with S9 Travels',

        "topPlaces": [
            {
              "title": "Malshej Falls",
              "description": "Malshej Falls is a beautiful waterfall nestled in the Sahyadri ranges. It is one of the most popular attractions in Malshej Ghat, especially during the monsoon season when the waterfall is in full flow. The area around the falls offers scenic views and is perfect for nature walks and photography."
            },
            {
              "title": "Harishchandragad Fort",
              "description": "Harishchandragad Fort, located near Malshej Ghat, is a popular trekking destination. The fort offers breathtaking views of the surrounding hills and valleys. The trek is a bit challenging but rewarding with panoramic views and historical significance."
            },
            {
              "title": "Pimpalgaon Joga Dam",
              "description": "Pimpalgaon Joga Dam, located near Malshej Ghat, is a scenic spot ideal for a peaceful retreat. The dam is surrounded by lush greenery and is a great spot for nature lovers to relax and enjoy the calm waters. The area is also home to a variety of bird species, making it a favorite spot for birdwatching."
            },
            {
              "title": "Ajoba Hill Fort",
              "description": "Ajoba Hill Fort is a lesser-known fort near Malshej Ghat. It is a serene location ideal for trekking and adventure enthusiasts. The trek offers stunning views and a chance to experience the natural beauty of the Sahyadri mountains."
            },
            {
              "title": "Kothaligad Fort (Peth Fort)",
              "description": "Kothaligad Fort, also known as Peth Fort, is a small but historical fort located near Malshej Ghat. It is known for its unique pyramid-like shape and is a popular trekking destination. The fort offers fantastic views of the surrounding landscape and is a peaceful spot to unwind."
            },
            {
              "title": "Malshej Ghat Viewpoints",
              "description": "The numerous viewpoints along Malshej Ghat offer mesmerizing views of the surrounding valleys, hills, and waterfalls. The viewpoints are perfect for photography, nature walks, and enjoying the serene environment of the ghats."
            },
            {
              "title": "Shivneri Fort",
              "description": "Shivneri Fort, located near Malshej Ghat, is historically significant as the birthplace of Chhatrapati Shivaji Maharaj. The fort offers a glimpse into Maharashtra's rich history and provides stunning views of the surrounding area. It's a great spot for history enthusiasts and trekkers alike."
            },
            {
              "title": "Sakarwadi Lake",
              "description": "Sakarwadi Lake is a picturesque and tranquil location near Malshej Ghat. The lake is surrounded by lush greenery and is ideal for picnics, nature walks, and birdwatching. The calm atmosphere makes it a great place to relax and enjoy the beauty of nature."
            }
          ],

          "services": [
            {
              "name": "Book Pune to Malshej Ghat Taxi",
              "description": "S9 Travels offers comfortable and reliable taxi services from Pune to Malshej Ghat. Whether it's for a peaceful getaway or a weekend retreat, our professional drivers and well-maintained vehicles ensure a smooth journey."
            },
            {
              "name": "Book Pune to Malshej Ghat Cab Booking",
              "description": "For a hassle-free and comfortable ride, book your Pune to Malshej Ghat cab with S9 Travels. We offer simple booking options, ensuring your trip is stress-free and enjoyable."
            },
            {
              "name": "Pune to Malshej Ghat Taxi Service",
              "description": "S9 Travels provides excellent taxi services from Pune to Malshej Ghat, making your journey pleasant and convenient. Our reliable drivers ensure your trip is safe and comfortable, allowing you to enjoy the scenic beauty of the ghat."
            },
            {
              "name": "Pune to Malshej Ghat One-Way Taxi",
              "description": "Looking for a one-way taxi to Malshej Ghat from Pune? S9 Travels offers one-way taxi services for a direct and comfortable ride to your destination. Travel at your convenience with no hidden charges."
            },
            {
              "name": "Pune to Malshej Ghat Round Trip",
              "description": "Plan a round trip from Pune to Malshej Ghat with S9 Travels. We provide flexible options, ensuring that your journey is smooth, comfortable, and punctual, whether it's a one-day trip or a weekend getaway."
            },
            {
              "name": "Pune to Malshej Ghat Cab Fare",
              "description": "S9 Travels offers transparent and competitive cab fares for your journey from Pune to Malshej Ghat. We ensure no hidden charges, and you can rest assured that your travel costs are clear and fair."
            },
            {
              "name": "Pune to Malshej Ghat Car Rental",
              "description": "S9 Travels provides car rental services for your trip to Malshej Ghat from Pune. Choose from our wide selection of well-maintained vehicles for a comfortable and customized travel experience."
            },
            {
              "name": "Pune to Malshej Ghat Luxury Taxi",
              "description": "Travel in style with our luxury taxi services from Pune to Malshej Ghat. Enjoy a premium experience with extra space, comfort, and a smooth ride as you explore the scenic beauty of the ghat."
            },
            {
              "name": "Pune to Malshej Ghat Efficient Taxi",
              "description": "For a more affordable option, S9 Travels offers Efficient Taxi services from Pune to Malshej Ghat. Share your ride with others and enjoy a cost-effective journey to the picturesque destination."
            },
            {
              "name": "Malshej Ghat Taxi Service from Pune",
              "description": "S9 Travels offers reliable Malshej Ghat taxi services from Pune. Our well-maintained vehicles and professional drivers ensure that your trip to this beautiful destination is comfortable and stress-free."
            },
            {
              "name": "Affordable Pune to Malshej Ghat Cab",
              "description": "Looking for an affordable taxi from Pune to Malshej Ghat? S9 Travels offers cost-effective options without compromising on comfort or safety. Plan your trip without worrying about the expenses."
            },
            {
              "name": "Pune to Malshej Ghat Private Cab",
              "description": "For a more personalized travel experience, S9 Travels offers private cabs from Pune to Malshej Ghat. Travel in complete comfort and privacy, with a dedicated driver to ensure your journey is seamless."
            },
            {
              "name": "Weekend Malshej Ghat Tour from Pune",
              "description": "Looking for a weekend getaway? S9 Travels offers weekend tours to Malshej Ghat from Pune. Enjoy a relaxing trip to the picturesque ghat with our convenient and affordable taxi services."
            },
            {
              "name": "Malshej Ghat Road Trip Taxi",
              "description": "Enjoy a scenic road trip to Malshej Ghat with S9 Travels. Our experienced drivers will guide you on your journey, ensuring a smooth and enjoyable experience as you explore the breathtaking views along the way."
            }
          ],


"tableData": [
  ["Book Pune To Malshej Ghat Taxi", "Book Pune To Malshej Ghat Cab Booking"],
  ["Book Pune To Malshej Ghat Taxi Service", "Book Pune To Malshej Ghat One-Way Taxi"],
  ["Book Pune To Malshej Ghat Round Trip", "Book Pune To Malshej Ghat Cab Fare"],
  ["Book Pune To Malshej Ghat Car Rental", "Book Pune To Malshej Ghat Luxury Taxi"],
  ["Book Pune To Malshej Ghat Efficient Taxi", "Malshej Ghat Taxi Service from Pune"],
  ["Affordable Pune to Malshej Ghat Cab", "Pune to Malshej Ghat Private Cab"],
  ["Weekend Malshej Ghat Tour from Pune", "Malshej Ghat Road Trip Taxi"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand that Malshej Ghat is a popular destination for nature lovers and adventure seekers. Our drivers ensure timely pickups and drop-offs, so you can enjoy your scenic journey without any delays. Whether it's a weekend getaway or a peaceful retreat, we make sure your trip is hassle-free."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a range of well-maintained vehicles, including sedans, SUVs, and premium cars, for your trip from Pune to Malshej Ghat. Our vehicles are equipped with comfortable seating, air conditioning, and ample luggage space, ensuring a pleasant and relaxing journey through the mountains."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced in handling mountain routes and are familiar with the scenic roads leading to Malshej Ghat. They prioritize your safety and comfort, ensuring a smooth and safe journey as you enjoy the natural beauty of the area."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for your Pune to Malshej Ghat trip. We provide a clear breakdown of costs with no hidden charges, so you know exactly what to expect. Our transparent pricing ensures a stress-free experience, with no surprises along the way."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring a secure and comfortable journey. Relax and enjoy the scenic beauty of Malshej Ghat, knowing that we have taken every step to ensure your safety."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you're planning an early morning trip or a late-night return, S9 Travels is available around the clock. Our customer service team is ready to assist with bookings and any other inquiries you may have, making your trip planning easy and flexible."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Malshej Ghat cab with S9 Travels is simple and convenient. You can book easily online through our website or mobile app, or contact our customer service team for personalized assistance with your booking."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you're visiting Malshej Ghat for sightseeing, photography, or a relaxing weekend, we offer customized travel packages that suit your preferences. Let us know your requirements, and we'll tailor your trip to make it special."
  }
]

















    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Malshej Ghat cab with S9 Travels?',
            answer: 'Booking is easy! You can book a cab online through our website or app, or you can contact our customer service team for personalized assistance with your booking.',
          },
          {
            question: 'What types of vehicles are available for the Pune to Malshej Ghat trip?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and premium cars. All our vehicles are well-maintained and designed to provide comfort and safety on mountain routes.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel to Malshej Ghat?',
            answer: 'Yes, all our drivers are highly skilled and experienced in driving on mountain roads. They are familiar with the best routes to Malshej Ghat and ensure a safe and smooth journey.',
          },
          {
            question: 'How do I pay for my Pune to Malshej Ghat cab rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, making it convenient for you to pay for your ride.',
          },
          {
            question: 'Can I book a round-trip from Pune to Malshej Ghat?',
            answer: 'Yes, we can arrange a round-trip for you. Simply provide us with your return details, and we’ll ensure a smooth and hassle-free return journey.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any extra charges for waiting times or detours will be communicated to you upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Malshej Ghat?',
            answer: 'Yes, we offer sightseeing services in Malshej Ghat. Explore the natural beauty of Malshej Ghat, including the famous waterfalls, forts, and viewpoints, with the help of our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Malshej Ghat cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have more luggage or special requirements, please inform us during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel to Malshej Ghat?',
            answer: 'Yes, we offer corporate and group travel services to Malshej Ghat. Whether it’s a team outing or a group of friends or family, we ensure a comfortable and safe journey for everyone.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Malshej Ghat trip?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. We prioritize your safety and comfort, ensuring a smooth trip to Malshej Ghat.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Vikram Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“We booked a cab with S9 Travels for a weekend trip to Malshej Ghat. The vehicle was clean and comfortable, and the driver was very friendly and professional. It was a great experience, and we enjoyed the scenic drive.”',
        },
        {
          name: 'Mrs. Aarti Mehta',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family had an amazing time in Malshej Ghat, thanks to S9 Travels. The vehicle was perfect for our trip, and the driver was very knowledgeable about the area. We’ll definitely book again!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune To Malshej Ghat Cab",
        "description": "Book Pune to Malshej Ghat cab services with S9 Travels. Whether you're looking for a one-way taxi, round-trip, luxury taxi, or car rental, we offer affordable and reliable transport to Malshej Ghat. Book your private cab, Efficient Taxi, or weekend tour now for a comfortable road trip to Malshej Ghat from Pune.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
    
      
      


    return (
        <div>
           <Helmet>
        <title>Pune To Malshej Ghat Cab | Affordable Taxi & Car Rental Services | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune to Malshej Ghat taxi services, one-way, round-trip, luxury taxis, Efficient Taxis, and car rentals with S9 Travels. Get the best fares for your weekend Malshej Ghat tour, road trip, and private cab booking for a scenic journey from Pune." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/21.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomalshejghatccab;